
import { copyToClipboard } from 'quasar'
import { Component, Prop, Vue } from 'vue-property-decorator'

import PixModel from '../models/Pix'

import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class Pix extends Vue {
  @Prop({ required: true }) readonly pix!: PixModel

  copied = false;

  private async copyPixCode() {
    const pixCode = this.pix.code

    try {
      await copyToClipboard(pixCode)

      this.copied = true
      this.$emit('copy')
      setTimeout(() => { this.copied = false }, 1100)
    } catch (err) {
      console.error(err)
    }
  }
}
